<template>
    <div class="permission-item">
        <permission-info :icon="icon" :text="description" />
        <permission-toggle :is-active="isSelected" :is-disabled="isDisabled" @toggle="togglePermission" />
    </div>
</template>

<script>
import PermissionInfo from './PermissionInfo.vue';
import PermissionToggle from './PermissionToggle.vue';
import { getActionIcon } from './IconUtils';
import { getPermissionDescription } from '../utils/Permissions';

export default {
    name: 'PermissionItem',
    components: {
        PermissionInfo,
        PermissionToggle
    },
    props: {
        permission: {
            type: Object,
            required: true
        },
        isSelected: {
            type: Boolean,
            default: false
        },
        isDisabled: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        icon() {
            const action = this.permission.name.split('.')[2] || this.permission.name.split('.')[1];
            return getActionIcon(action);
        },
        description() {
            try {
                return getPermissionDescription(this.permission.name);
            } catch (error) {
                return this.permission.name.split('.').pop();
            }
        }
    },
    methods: {
        togglePermission() {
            if (!this.isDisabled) {
                this.$emit('toggle', this.permission);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.permission-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.6rem 0;
    width: 100%;
    border-radius: 4px;
    transition: all 0.2s ease;
    cursor: pointer;

    &:not(:last-child) {
        border-bottom: 1px solid #f5f5f5;
    }

    &:hover {
        background-color: #f8f9fa;
    }
}
</style>